import { VisuallyHidden as RadixVisuallyHidden } from 'radix-ui'

export const VisuallyHidden = RadixVisuallyHidden.Root
